import clsx, { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export const getInitialName = (name: string): string => {
  const nameParts = name.split(" ").filter(Boolean);
  const initials = nameParts.slice(0, 2).map((part) => part[0].toUpperCase());
  return initials.join(".");
};

export function formatHtml(html: string): string {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const voidElements = new Set([
      "area","base","br","col","embed","hr","img","input","link","meta","param","source","track","wbr"
    ]);

    const attrString = (el: Element) =>
      Array.from(el.attributes)
        .map((a) => `${a.name}="${a.value.replace(/"/g, '&quot;')}"`)
        .join(" ");

    const pretty = (node: ChildNode, depth = 0): string => {
      const indent = "  ".repeat(depth);
      if (node.nodeType === Node.TEXT_NODE) {
        const txt = node.textContent ?? "";
        const trimmed = txt.replace(/\s+/g, " ").trim();
        return trimmed ? indent + trimmed + "\n" : "";
      }
      if (node.nodeType === Node.COMMENT_NODE) {
        return indent + `<!-- ${node.textContent} -->\n`;
      }
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node as Element;
        const tag = el.tagName.toLowerCase();
        const attrs = attrString(el);
        const open = attrs ? `<${tag} ${attrs}>` : `<${tag}>`;

        if (voidElements.has(tag)) {
          return indent + (attrs ? `<${tag} ${attrs} />` : `<${tag} />`) + "\n";
        }

        const children = Array.from(el.childNodes)
          .map((c) => pretty(c, depth + 1))
          .join("");

        if (!children) {
          return indent + open.replace(/>$/, `></${tag}>\n`);
        }

        return indent + open + "\n" + children + indent + `</${tag}>\n`;
      }
      return "";
    };

    const bodyChildren = Array.from(doc.body.childNodes);
    const result = bodyChildren.map((n) => pretty(n, 0)).join("");
    return result || html;
  } catch (err) {
    return html;
  }
}

